
const Attribution = () => {
    return(
    <div className="attribution">
        Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank">Frontend Mentor</a>. 
        Coded by <a href="#">Santiago Valdez</a>.
    </div>)
}

export default Attribution;